<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <button class="btn-back" @click="votar">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                        </svg>
                                        Voltar
                                    </button>
                                    <h1 class="modern-title">Banco de Penalidades</h1>
                                    <p class="modern-subtitle">Detalhamento das penalidades aplicadas ao fornecedor</p>
                                </div>
                                <div class="header-actions">
                                    <button class="modern-btn modern-btn-secondary" @click="imprimir">
                                        Imprimir
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="page-container" v-if="penalidade" id="imprimir">

                    <!-- Supplier identity card -->
                    <div class="det-identity-card">
                        <div class="det-identity-card__bar" aria-hidden="true"></div>
                        <div class="det-identity-card__content">
                            <div class="det-identity-card__header">
                                <span class="det-identity-card__label">Fornecedor</span>
                                <span class="det-count-badge">
                                    <i class="fas fa-exclamation-triangle"></i>
                                    {{ penalidade.detalhesFontesPenalidades?.length ?? 0 }}
                                    {{ (penalidade.detalhesFontesPenalidades?.length ?? 0) === 1 ? 'penalidade' : 'penalidades' }}
                                </span>
                            </div>
                            <h2 class="det-identity-card__razao">
                                {{ penalidade.razaoSocial || '—' }}
                            </h2>
                            <div class="det-identity-card__meta">
                                <span class="det-meta-chip">
                                    <i class="fas fa-id-card"></i>
                                    {{ penalidade.cnpj || '—' }}
                                </span>
                                <span class="det-meta-chip" v-if="penalidade.uf">
                                    <i class="fas fa-map-marker-alt"></i>
                                    {{ penalidade.uf }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Penalties list -->
                    <div class="det-penalties">
                        <div class="det-section-title">
                            <i class="fas fa-list-ul"></i>
                            Registros de Penalidade
                        </div>

                        <div class="det-penalty-card"
                             v-for="(item, index) in penalidade.detalhesFontesPenalidades"
                             :key="index"
                             :style="{ animationDelay: `${index * 70}ms` }">

                            <!-- Card top row -->
                            <div class="det-penalty-card__topbar">
                                <span class="det-penalty-card__index">#{{ index + 1 }}</span>
                                <span class="det-status-badge det-status-badge--ativa" v-if="statusPenalidade(item.dataFinal)">
                                    <i class="fas fa-times-circle noPrint"></i>
                                    Penalidade Ativa
                                </span>
                                <span class="det-status-badge det-status-badge--inativa" v-else>
                                    <i class="fas fa-check-circle noPrint"></i>
                                    Penalidade Inativa
                                </span>
                            </div>

                            <!-- Two-column grid -->
                            <div class="det-penalty-card__grid">

                                <!-- Left column -->
                                <div class="det-fields-group">
                                    <div class="det-field">
                                        <span class="det-field__label">Processo</span>
                                        <span class="det-field__value">{{ item.processo || '—' }}</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Fundamentação Legal</span>
                                        <span class="det-field__value">{{ item.tipoSancao || '—' }}</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Período</span>
                                        <span class="det-field__value">
                                            <template v-if="item.dataAcordao && item.dataFinal">
                                                {{ item.dataAcordao }}
                                                <span class="det-field__period-arrow">→</span>
                                                {{ item.dataFinal }}
                                            </template>
                                            <template v-else>
                                                Período não encontrado
                                            </template>
                                        </span>
                                    </div>
                                    <div class="det-field det-field--highlight">
                                        <span class="det-field__label">Penalidade</span>
                                        <span class="det-field__value">{{ item.detalhe || '—' }}</span>
                                    </div>
                                </div>

                                <!-- Divider -->
                                <div class="det-penalty-card__divider" aria-hidden="true"></div>

                                <!-- Right column -->
                                <div class="det-fields-group">
                                    <div class="det-field">
                                        <span class="det-field__label">Nº Fundamentação Legal</span>
                                        <span class="det-field__value">{{ item.deliberacao || '—' }}</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Data Publicação</span>
                                        <span class="det-field__value">{{ item.dataPublicacao || '—' }}</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Descrição Publicação</span>
                                        <span class="det-field__value det-field__value--muted">—</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Detalhes Meio Publicação</span>
                                        <span class="det-field__value det-field__value--muted">—</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Data Trânsito</span>
                                        <span class="det-field__value">{{ item.dtTransEmJulgado || '—' }}</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Abrangência Decisão Judicial</span>
                                        <span class="det-field__value det-field__value--muted">—</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Órgão Sancionador</span>
                                        <span class="det-field__value">{{ item.entitdadeSancionadora || '—' }}</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Complemento Órgão Sancionador</span>
                                        <span class="det-field__value det-field__value--muted">—</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">UF Órgão Sancionador</span>
                                        <span class="det-field__value">{{ item.uf || '—' }}</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Origem Informação</span>
                                        <span class="det-field__value">{{ item.fonte || '—' }}</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Endereço</span>
                                        <span class="det-field__value det-field__value--muted">—</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Contato Origem Informação</span>
                                        <span class="det-field__value det-field__value--muted">—</span>
                                    </div>
                                    <div class="det-field">
                                        <span class="det-field__label">Data Informação</span>
                                        <span class="det-field__value">{{ item.dataPublicacao || '—' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                </div>
            </div>
        </div>
        <Modais></Modais>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import { urlApi } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default defineComponent({
        name: 'DetalhePenalidade',
        components: { Header, Modais },

        data() {
            return {
                penalidade: history.state.penalidade ?? null,
                pesquisa: history.state.pesquisa ?? {},
                idPesquisaPenalidade: history.state.idPesquisaPenalidade ?? null,
            }
        },

        computed: {
            user() { return this.$store.state.user },
        },

        methods: {
            votar() { this.$router.go(-1) },

            load() {
                if (!this.penalidade) {
                    this.$router.push({ name: 'BancoPenalidades' })
                    return
                }
                this.geraLogPesquisaResultado()
            },

            geraLogPesquisaResultado() {
                axios.post(`${urlApi}/Log/LogBancoPenalidadesResultado`, {
                    idPesquisaPenalidade: this.idPesquisaPenalidade,
                    idFornecedor: this.penalidade?.idPenalidade,
                }).then((res) => {
                    if (res.data?.success) console.log('log ok')
                })
            },

            statusPenalidade(dtFim) {
                return moment(dtFim, 'DD/MM/YYYY') > moment()
            },

            async imprimir() {
                axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog: 'SC_DWN_BANPEN' }).catch(() => { })
                const options = {
                    name: '_blank',
                    specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                    styles: [
                        'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css',
                        'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.13.1/css/svg-with-js.min.css',
                        'assets/css/detalhe-penalidade-print.css',
                    ],
                    timeout: 1000,
                    autoClose: true,
                    windowTitle: window.document.title,
                }
                await this.$htmlToPaper('imprimir', options)
            },
        },

        mounted() { this.load() },
    })
</script>

<style lang="scss" scoped>
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .btn-back {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: none;
        color: #6b7280;
        font-size: 13px;
        font-weight: 600;
        padding: 0;
        margin-bottom: 4px;
        cursor: pointer;
        width: fit-content;
    }

    .btn-back:hover {
        color: #2563eb;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        min-height: 42px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
        color: white;
    }

    .modern-btn-secondary:hover {
        background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
    }

    .page-container {
        max-width: 1140px;
        margin: 0 auto;
        padding: 24px 16px 48px;
        overflow-x: auto;
    }

    .det-identity-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        display: grid;
        grid-template-columns: 6px 1fr;
        margin-bottom: 28px;
        border: 1px solid #e5e7eb;
    }

    .det-identity-card__bar {
        background: #2563eb;
    }

    .det-identity-card__content {
        padding: 24px 28px;
    }

    .det-identity-card__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        gap: 12px;
        flex-wrap: wrap;
    }

    .det-identity-card__label {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .12em;
        text-transform: uppercase;
        color: #6b7280;
    }

    .det-count-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: rgba(37, 99, 235, 0.1);
        color: #1d4ed8;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .06em;
        text-transform: uppercase;
        padding: 4px 14px;
        border-radius: 20px;
    }

    .det-identity-card__razao {
        font-size: 20px;
        font-weight: 800;
        color: #1f2937;
        margin: 0 0 14px;
        line-height: 1.3;
        letter-spacing: -0.3px;
    }

    .det-identity-card__meta {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }

    .det-meta-chip {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        background: #f8fafc;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 5px 14px;
        font-size: 13px;
        font-weight: 600;
        color: #1f2937;
    }

    .det-section-title {
        font-size: 18px;
        font-weight: 800;
        color: #1f2937;
        display: flex;
        align-items: center;
        gap: 10px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e5e7eb;
        margin-bottom: 20px;
    }

    .det-section-title i {
        color: #2563eb;
    }

    .det-penalty-card {
        background: #fff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        margin-bottom: 18px;
    }

    .det-penalty-card__topbar {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 14px 24px;
        background: #f8fafc;
        border-bottom: 1px solid #e5e7eb;
    }

    .det-penalty-card__index {
        font-size: 12px;
        font-weight: 800;
        letter-spacing: .1em;
        color: #6b7280;
        text-transform: uppercase;
    }

    .det-status-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .06em;
        text-transform: uppercase;
        padding: 4px 14px;
        border-radius: 20px;
    }

    .det-status-badge--ativa {
        background: rgba(239, 68, 68, 0.1);
        color: #dc2626;
        border: 1px solid rgba(239, 68, 68, 0.2);
    }

    .det-status-badge--inativa {
        background: rgba(22, 163, 74, 0.1);
        color: #16a34a;
        border: 1px solid rgba(22, 163, 74, 0.2);
    }

    .det-penalty-card__grid {
        display: grid;
        grid-template-columns: 1fr 1px 1fr;
        gap: 0;
        padding: 24px;
    }

    .det-penalty-card__divider {
        background: #e5e7eb;
        margin: 0 24px;
    }

    .det-field {
        padding: 10px 0;
        border-bottom: 1px solid #f3f4f6;
    }

    .det-field:last-child {
        border-bottom: none;
    }

    .det-field--highlight {
        background: rgba(37, 99, 235, 0.06);
        border-radius: 8px;
        border-bottom: none;
        padding: 10px 12px;
    }

    .det-field__label {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .08em;
        text-transform: uppercase;
        color: #6b7280;
        margin-bottom: 3px;
        display: block;
    }

    .det-field__value {
        font-size: 14px;
        color: #1f2937;
        font-weight: 500;
        line-height: 1.5;
        word-break: break-word;
    }

    .det-field__value--muted {
        color: #9ca3af;
        font-style: italic;
    }

    .det-field__period-arrow {
        margin: 0 6px;
        color: #2563eb;
        font-weight: 700;
    }

    [data-bs-theme="dark"] .det-identity-card,
    [data-bs-theme="dark"] .det-penalty-card {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .det-identity-card__razao,
    [data-bs-theme="dark"] .det-section-title,
    [data-bs-theme="dark"] .det-field__value {
        color: #f9fafb;
    }

    @media (max-width: 768px) {
        .modern-title {
            font-size: 24px;
        }

        .header-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .det-penalty-card__grid {
            grid-template-columns: 1fr;
            padding: 16px;
        }

        .det-penalty-card__divider {
            height: 1px;
            width: 100%;
            margin: 16px 0;
        }
    }

    @media print {
        .btn-back,
        .modern-btn,
        .noPrint {
            display: none !important;
        }
    }
</style>